// 
// Javascript to hide accordions if empty on certain pages
//
document.addEventListener('DOMContentLoaded', function() {
  // Get all elements with class 'template-product'
  var templateProducts = document.querySelectorAll('.template-product');
  
  // Loop through each 'template-product' element
  templateProducts.forEach(function(templateProduct) {
    // Call the function for each ID you want to check within the current 'template-product'
    hideParentIfNoPTags(templateProduct, 'accordion-content-description');
    hideParentIfNoPTags(templateProduct, 'accordion-content-accordion-1');
    hideParentIfNoPTags(templateProduct, 'accordion-content-accordion-2');
    hideParentIfNoPTags(templateProduct, 'accordion-content-accordion-3');
    hideParentIfNoPTags(templateProduct, 'accordion-content-d579ba22-0695-4e3e-b53a-5be9c84a0a4a');
    hideParentIfNoPTags(templateProduct, 'accordion-content-2cff98a2-4f43-4b7a-a176-d007b0a58218');
    hideParentIfNoPTags(templateProduct, 'accordion-content-dbafb2c2-7ea2-4d47-b085-fc393fd3c65e');
  });
  
  // Function to hide the parent element if it doesn't contain <p> tags
  function hideParentIfNoPTags(templateProduct, elementId) {
    var accordionContent = templateProduct.querySelector('#' + elementId);
    if (!accordionContent) {
      return; // Exit if element with given ID doesn't exist within the current 'template-product'
    }
    
    var pTags = accordionContent.querySelectorAll('p');
    var imgTags = accordionContent.querySelectorAll('img');

    // Check if there are no <p> tags within the accordion content
    if (pTags.length === 0 && imgTags.length === 0) {
      var accordionInner = findParentWithClass(accordionContent, 'accordion__inner');
      if (accordionInner) {
        accordionInner.style.display = 'none';
      }
    }
  }

  // Function to find the closest parent element with a specified class
  function findParentWithClass(element, className) {
    while ((element = element.parentElement)) {
      if (element.classList.contains(className)) {
        return element;
      }
    }
    return null;
  }
});


//
// Hide empty callout boxes
//

// Get all elements with class ".product__callouts-items[data-with-box=true]"
const blockCallouts = document.querySelectorAll('.product__callouts-items[data-with-box=true]');

// Loop through each block of callouts
blockCallouts.forEach((block) => {
  // Get all child elements with class "product__callouts-item" within the current block
  const calloutItems = block.querySelectorAll('.product__callouts-item');
  let allEmpty = true; // Assume all are empty initially

  // Loop through each "product__callouts-item" within the block
  calloutItems.forEach((item) => {
    // Find the <p> element within the current item
    const paragraph = item.querySelector('p');

    // Check if the <p> element exists and contains a <strong> tag
    if (paragraph) {
      const strongElement = paragraph.querySelector('strong');

      // Check if the <strong> tag exists and if it has a sibling
      if (strongElement && strongElement.nextSibling) {
        const textAfterStrong = strongElement.nextSibling;

        // Check if there is content after the <strong> tag
        if (textAfterStrong.nodeType === Node.TEXT_NODE && textAfterStrong.textContent.trim().length > 0) {
          // If there is content, set allEmpty to false
          allEmpty = false;
        }
      }
    }
  });

  // If all .product__callouts-item elements within the block have empty content, hide the block
  if (allEmpty) {
    block.style.display = 'none';
  }
});

// replaces $ signs with £ signs in

document.addEventListener("DOMContentLoaded", function() {
  
  let productFormItem = document.querySelector('.product-form__item');
                            
    if (productFormItem) {


        productFormItem.addEventListener ("DOMSubtreeModified", function(e, el){
        
          document.querySelectorAll("og-price").forEach(
              function(ogPrice){
                let priceNode = ogPrice.shadowRoot.childNodes[4];
                priceNode.nodeValue = priceNode.nodeValue.replace("$", "£");
              }
          );
        });
      
    }
});

// try to ensure that videos autoplay if they become visible

document.addEventListener("DOMContentLoaded", function() {


  let mediaGallery = document.querySelectorAll(".product__media-item");

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver( function(mutationList){

    for (const mutation of mutationList) {

      if (mutation.type === "attributes") {

        // if old value had hidden in it and new value doesnt -- find the video and play it
        if ( (mutation.oldValue.indexOf('hidden') !== -1 ) && (mutation.target.className.indexOf('hidden') === -1 ) ){

          let videoEl = mutation.target.querySelector("video");

          if(videoEl){
            videoEl.play();
          }
        }

        // or if old value had swiper-slide-visible in it and new value doesnt -- find the video and play it
        if ( (mutation.oldValue.indexOf('swiper-slide-visible') === -1 ) && (mutation.target.className.indexOf('swiper-slide-visible') !== -1 ) ){

          let videoEl = mutation.target.querySelector("video");

          if(videoEl){
            videoEl.play();
          }
        }
        
      }
    }
  });


  const config = { attributes: true, attributeFilter: ['class'], attributeOldValue : true };

  mediaGallery.forEach( function( item ){
      observer.observe(item, config);
  });

});



// make sure that starting the quiz doesnt also start the page transition
document.addEventListener("DOMContentLoaded", function() {

  let quizLinks = document.querySelectorAll('a[href*="#quiz"]');
  
  quizLinks.forEach( function( item, index ){
    item.classList.add('no-transition');
  } );
  

} );


// // fix bug related to users going back to PDP and not seeing correct count in basket, by refreshing the side/mini cart
// document.addEventListener("DOMContentLoaded", function() {
//   // if this is the PDP - refresh the minicart
//   if( document.body.classList.contains('template-product')){
//     document.dispatchEvent(new CustomEvent( 'apps:product-added-to-cart' ));
//   }
// } );


// JS for custom mobile menu
function setActive(elementId) {
  document.getElementById(elementId).classList.add('active');
}

function removeActive() {
  ['product-type', 'health-focus', 'about', 'take-control'].forEach(function(id) {
    document.getElementById(id).classList.remove('active');
  });
}

document.querySelectorAll('.mobile-menu button').forEach(function(link) {
  link.addEventListener('click', function() {
    if (link.classList.contains('product-menu')) {
      setActive('product-type');
    } else if (link.classList.contains('health')) {
      setActive('health-focus');
    } else if (link.classList.contains('about')) {
      setActive('about');
    } else if (link.classList.contains('take-control')) {
      setActive('take-control');
    }
  });
});

document.querySelectorAll('.mobile-menu .m-back').forEach(function(link) {
  link.addEventListener('click', removeActive);
});


document.addEventListener('DOMContentLoaded', function() {
  var mobileMenu = document.querySelector('.mobile-menu');
  var mobileMenuBtn = document.querySelector('.mobile-menu-btn');
  var body = document.querySelector('body');

  mobileMenuBtn.addEventListener('click', function() {
      mobileMenu.classList.toggle('active');
      body.classList.toggle('no-scroll');

      // Toggle aria-expanded attribute
      var expanded = mobileMenuBtn.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
      mobileMenuBtn.setAttribute('aria-expanded', expanded);
  });
});

/*
* PLP Quick add to Basket code
* */
document.addEventListener('DOMContentLoaded', function () {
    window.setTimeout(function() {
        document.querySelectorAll('.quick-add-to-basket.btn').forEach(function (el) {
            el.addEventListener('click', handleQuickAddToCart);
        });
    }, 300)
});

function handleQuickAddToCart(e) {

    // let productId = el.closest('form').dataset.currentProductId;
    let productId = this.dataset.currentProductId;

    let formData = {
        'items': [{
            'id': productId,
            'quantity': 1
        }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(response => {
            window.setTimeout(function() {
                document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
                document.querySelector('[data-js-cart-icon]').click();
            }, 500);
            return response.json();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}


/*
* Account Menu
* */
document.addEventListener("DOMContentLoaded", function () {
  // Cache elements
  var accountLinks = document.querySelectorAll('[data-account-menu]');
  var mobileAccountBtn = document.querySelector('.mobile-account-btn');

  if (!mobileAccountBtn || !accountLinks.length)
      return null;

  var menuArrow = mobileAccountBtn.querySelector('.menu-arrow');
  var accountMenu = mobileAccountBtn.nextElementSibling;

  // Handle tab switching and menu closing
  accountLinks.forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();

      var accountId = link.getAttribute('data-account-menu');
      var allTabs = document.querySelectorAll('.account-tab');

      // Hide all tabs and remove active state from links
      allTabs.forEach(function (tab) {
        tab.classList.remove('open');
      });
      accountLinks.forEach(function (otherLink) {
        otherLink.classList.remove('active');
      });

      // Show selected tab and update button content
      var selectedTab = document.getElementById(accountId);
      if (selectedTab) {
        selectedTab.classList.add('open');
        link.classList.add('active');

        // Update button content while keeping the arrow intact
        mobileAccountBtn.innerHTML = link.innerHTML;
        mobileAccountBtn.appendChild(menuArrow);
      }

      // Close the menu and rotate the arrow back smoothly
      accountMenu.classList.remove('open');
      menuArrow.classList.remove('rotate');
    });
  });

  // Handle menu toggle
  mobileAccountBtn.addEventListener('click', function (event) {
    event.preventDefault();
    accountMenu.classList.toggle('open');

    // Toggle arrow rotation
    menuArrow.classList.toggle('rotate');
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // Get the .account__menu element
  var accountMenu = document.querySelector('.account__menu');

  if (!accountMenu) {
    return null;
  }

  // Add click event listener to all <a> tags within .account__menu
  accountMenu.addEventListener('click', function (event) {
    // Check if the clicked element is an <a> tag
    if (event.target.tagName === 'A') {
      // Remove the 'open' class from .account__menu
      accountMenu.classList.remove('open');
    }
  });
});


// Account links to each tab
document.addEventListener('DOMContentLoaded', function () {
  if (document.body.classList.contains('template-customers-account')) {
      const menuItems = {
          '#gfc': 'gfc',
          '#subscriptions': 'subscriptions',
          '#orders': 'orders',
          '#details': 'details'
      };
  
      const hash = window.location.hash;
  
      if (hash && menuItems.hasOwnProperty(hash)) {
          const menuItemKey = menuItems[hash];
          window.setTimeout(() => {
              const gfcMenuItem = document.querySelector(`[data-account-menu="${menuItemKey}"]`);
              if (gfcMenuItem) {
                  gfcMenuItem.click();
              }
          }, 0);
      }
  }
});


// Add price points to LL tiers on GFC page

// Function to set the text content of the element
function setTextContent(className, text) {
    var elements = document.querySelectorAll(className);
    elements.forEach(function(element) {
        element.innerHTML = text;
    });
}

// Delay the execution of setTextContent after the page has loaded
window.onload = function() {
    setTimeout(function() {
        setTextContent('.lion-tier-compare__header-cell--tier-0', 'Hacker <span class="level-subtext">£0 - £99.99</span>');
        setTextContent('.lion-tier-compare__header-cell--tier-1', 'Biohacker <span class="level-subtext">£100 - £249.99</span>');
        setTextContent('.lion-tier-compare__header-cell--tier-2', 'Superhacker <span class="level-subtext">£250 - £999.99</span>');
        setTextContent('.lion-tier-compare__header-cell--tier-3', 'Immortal Hacker <span class="level-subtext">£1000 +</span>');
    }, 100);
};



/* refresh minicart when adding to basket from Okendo quiz */
document.addEventListener('oke_quizCapture_addToCart', function () {
    document.dispatchEvent(new CustomEvent( 'apps:product-added-to-cart' ));
});



/* Close search box if menu is opening- cloes menu if search box is opening */
document.addEventListener("DOMContentLoaded", function() {

    let searchIconEl = document.querySelectorAll('.header__icon-touch--search');
    let menuIconEl = document.querySelectorAll('.header__menu-icon');
    let usClosing = false;

    searchIconEl.forEach( function(el) {

        el.addEventListener('click', function (e) {
            //close menu if open
            document.querySelectorAll( '.header__menu-icon[aria-expanded="true"]' ).forEach(function(el){

                if (usClosing)
                    return;

                usClosing = true;
                el.click();
                usClosing = false;
            })

        });
    });

    menuIconEl.forEach( function(el) {

        el.addEventListener('click', function (e) {

            document.querySelectorAll( '.header__icon-touch--search[aria-expanded="true"]' ).forEach(function(el){

                if (usClosing)
                    return;

                usClosing = true;
                el.click();
                usClosing = false;
            })

        });
    });

});


/* ___START___ On variant products - automatically switch the dropdown based on gallery image selected */
document.addEventListener("DOMContentLoaded", function() {

    /* if this isnt PDP - dont bother adding listeners */
    if ( ! document.querySelector('body').classList.contains('template-product') )
        return null;

    const productJson = document.querySelectorAll("[data-variant-json]");
    const thumbs =  document.querySelectorAll('.product-thumbnails__item-link');

    let variants = [];
    
    productJson.forEach( function(item){

        variants = JSON.parse(item.innerHTML);

    } );

    const getVariantByThumbnailId = function( thumbnailId ){

        let foundVariant = false;

        variants.forEach( function( variant ){
            
            if (variant.featured_media.id == thumbnailId){
                foundVariant = variant;
            }

        } );

        return foundVariant;

    };

    
    const setVariantByOptions = function(options){

        for( const index in options ){

            if (options[index]){
                document.getElementById(index).value = options[index];
                document.getElementById(index).dispatchEvent( new Event('change') );

            }

        }
        
    };
    
    thumbs.forEach(function(el){

        el.addEventListener('click', function (){

            let variant = getVariantByThumbnailId( this.dataset.thumbnailId );

            if (variant){

                setVariantByOptions( {
                    'option1': variant.option1,
                    'option2': variant.option2,
                    'option3': variant.option3
                } );

            }

        });

    });


    const getVariantByOptions = function( options ){

        let foundVariant = false;

        variants.forEach( function( variant ){

            if (
                variant.option1 === options.option1 &&
                variant.option2 === options.option2 &&
                variant.option3 === options.option3
            ){
                foundVariant = variant;
            }

        } );

        return foundVariant;

    };

    document.querySelectorAll('.dynamic-variant-input').forEach(function( el ){

        el.addEventListener('change', function(){

            let variant = getVariantByOptions( {
                'option1': document.getElementById('option1')?.value ?? null,
                'option2': document.getElementById('option2')?.value ?? null,
                'option3': document.getElementById('option3')?.value ?? null
            } );

            if (variant){

                let variantThumbnail = document.querySelector('[data-thumbnail-id="'+ variant.featured_media.id +'"');

                if (variantThumbnail){
                    variantThumbnail.click();
                }

            }

        });

    });


});

/* ___END___ On variant products - automatically switch the dropdown based on gallery image selected */


/** START - add reading time for article pages */

if( document.querySelector('body.template-article') ){

    let articleText = '';
    let stopCounting = false;

    document.querySelectorAll('.rte, .rich-text__heading').forEach( text => {

        if (stopCounting)
            return;

        if (
            text.innerText.toLowerCase().indexOf('further reading') !== 0
            &&
            text.innerText.toLowerCase().indexOf('further product information') !== 0
        ){
            articleText += text.innerText;
        }else{
            stopCounting = true;
        }

    } );

    const wordsArray = articleText.split(' ');

    const wordCount = wordsArray.length;

    const wordsPerMinute = 250;
    const readingTime = Math.ceil(wordCount / wordsPerMinute);

    
    const hero =  document.querySelector('.shopify-section--full-width .image-hero__text-container-inner');

    let readingTimeContainer = document.createElement("span");
    readingTimeContainer.classList.add('reading-time');
    readingTimeContainer.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="72" height="73" viewBox="0 0 72 73" fill="none"><path d="M38 16.5601H32V40.5601L51 51.9601L54 47.0401L38 37.5601V16.5601ZM36 0.560059C16.12 0.560059 0 16.6801 0 36.5601C0 56.4401 16.08 72.5601 36 72.5601C55.88 72.5601 72 56.4401 72 36.5601C72 16.6801 55.88 0.560059 36 0.560059ZM36 64.5601C20.52 64.5601 8 52.0401 8 36.5601C8 21.0801 20.52 8.56006 36 8.56006C51.48 8.56006 64 21.0801 64 36.5601C64 52.0401 51.48 64.5601 36 64.5601Z" fill="var(--color-text)"/></svg>'
                                        + readingTime + ' min';

    // hero.after(readingTimeContainer);

}

/** END add reading time for article pages */



/* ___START___ Add recommendationsAPI recomendations to quick cart */
document.addEventListener("DOMContentLoaded", function() {

    const getCart = async function(){
        const response = await fetch('/cart.js');
        return  await response.json();
    };

    const loadRecommendedProducts = async function () {

        const cart = await getCart();

        let productID = null;

        if(cart.items && cart.items.length){

            productID = cart.items[0].product_id;
        }else{
            return false;
        }

        let productRecommendationsSection = document.querySelectorAll('.product-recommendations');

        // replace the product_id with the first product id in the cart
        let urlParams = new URLSearchParams(productRecommendationsSection[0].dataset.url);

        urlParams.product_id = productID;

        // const url = productRecommendationsSection.dataset.url;
        const url = decodeURIComponent(urlParams.toString());

        fetch(url)
            .then(response => response.text())
            .then(text => {

                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.product-recommendations');

                if (recommendations && recommendations.innerHTML.trim().length) {

                    productRecommendationsSection.forEach( function(el){

                        el.innerHTML = recommendations.innerHTML;
                    } );

                }

                document.querySelectorAll('.product-recommendations .mycross-sells__item-add.btn').forEach(function (el) {

                    el.addEventListener('click', function (e) {

                        // let productId = el.closest('form').dataset.currentProductId;
                        let productId = el.dataset.addItemId;

                        let formData = {
                            'items': [{
                                'id': productId, 'quantity': 1
                            }]
                        };

                        // debugger;

                        fetch(window.Shopify.routes.root + 'cart/add.js', {
                            method: 'POST', headers: {
                                'Content-Type': 'application/json'
                            }, body: JSON.stringify(formData)
                        })
                            .then(response => {

                                // if this was a click on the main cart ... just reload the cart page - otherwise trigger the minicart reload
                                if(el.closest('.shopify-section.cart-section')){
                                    window.location.reload();
                                }else{
                                    document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
                                }
                                return response.json();

                            })
                            .catch((error) => {
                                console.error('Error:', error);
                            });
                    });
                });


            })
            .catch(e => {
                console.error(e);
            });
    };

    const handleIntersection = (entries, observer) => {

        if (!entries[0].isIntersecting) return;
        // observer.unobserve(productRecommendationsSection);
        loadRecommendedProducts();

    };

    let intersectionObserverAdded = false;

    const addIntersectionObserver = function(){

        const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
        let target = document.querySelector('.product-recommendations');

        if(target){
            observer.observe(target )
            intersectionObserverAdded = true;
        }

    };

    // document.addEventListener('apps:product-added-to-cart', function () {
    //     window.setTimeout( function(){ loadRecommendedProducts(); }, 1000 );
    // });

    document.addEventListener('cart:item-added', function () {
        /*
         if there was nothing in the cart - the intersection observer wont have been added cause the element wouldnt have existed, so add it once the cart is activated once item is added
         */
        if(! intersectionObserverAdded){
            addIntersectionObserver();
        }
    });

    addIntersectionObserver();

    // if this is the '/cart' page - run loadRecommendedProducts() at page load and respon to cart modifications

    if( document.querySelector('body.template-cart') ){

        // load recommended products on page load
        window.setTimeout( function(){ loadRecommendedProducts(); }, 250 );
    }


    // Select the node that will be observed for mutations
    const mainCartSection = document.querySelector(".main .cart-section");
    const quickCartSection = document.querySelector(".shopify-section .quick-cart");

    // Options for the observer (which mutations to observe)
    const config = {  childList: true, subtree: true  };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {

        let donereload = false;

        for (const mutation of mutationList) {

            if( ! donereload && ! mutation.target.classList.contains('product-recommendations') ){
                window.setTimeout( function(){ loadRecommendedProducts(); }, 250 );
                donereload = true;
            }
        }

    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    if (mainCartSection){
        observer.observe(mainCartSection, config);
    }

    if(quickCartSection){

        observer.observe(quickCartSection, config);
    }


});

/* ___END___ Add recommendationsAPI recomendations to quick cart */


/* ___START___ Hide table contents on PDP for size/origin etc if no content  */
document.addEventListener("DOMContentLoaded", function() {
    // Check if the .template-product class is present on the page
    const templateProduct = document.querySelector('.template-product');

    if (templateProduct) {
        // Select all product callouts item containers within .template-product
        const calloutsItems = templateProduct.querySelectorAll('.product__callouts-item');

        calloutsItems.forEach(function(item) {
            // Find the strong tag within the current item
            const strongTag = item.querySelector('p > strong');

            if (strongTag) {
                // Get the content after the strong tag
                const contentAfterStrong = strongTag.parentNode.textContent.replace(strongTag.textContent, '').trim();

                // Check if the content is empty (ignoring spaces)
                if (contentAfterStrong === '') {
                    // Hide the parent item if no content after the strong tag
                    item.style.display = 'none';
                }
            }
        });
    }
});

/* ___END___ Hide table contents on PDP for size/origin etc if no content  */

/* ___START___ GSAP Split Text Titles */

gsap.registerPlugin(SplitText);

var split = new SplitText(".background-title", {
    type: "words",
    wordsClass: "word"
});

// Remove space text nodes inside the parent element
document.querySelectorAll(".background-title").forEach(heading => {
    heading.childNodes.forEach(node => {
        if (node.nodeType === 3 && !/\S/.test(node.nodeValue)) {
            node.remove(); // Remove empty text nodes (spaces)
        }
    });
});

/* ___END___ GSAP Split Text Titles */

/* ___START___ Sticky add GSAP for Product */

gsap.registerPlugin(ScrollTrigger);

gsap.fromTo(".sticky-add",
  { y: 100, opacity: 0 },
  { 
    y: 0, 
    opacity: 1,
    duration: 0.5,
    ease: "power2.out",
    scrollTrigger: {
      trigger: document.body,
      start: "top+=100vh top",
      end: "top+=100vh 10%",
      toggleActions: "play none none reverse"
    }
  }
);

/* ___END___ Sticky add GSAP for Product */



// modify recharge widget after load
customElements.whenDefined('recharge-subscription-widget').then(() => {

    const widget = document.querySelector('recharge-subscription-widget');

    if (widget) {
        // Widget is defined and available
        // Your code here

        const shadowRoot = widget.shadowRoot;

        /* listen for mutaions of shadowroot; */

        let textAdded = false;
        // Create the observer instance
        const observer = new MutationObserver(function(mutations) {


            mutations.forEach(function(mutation) {
                // Handle mutations here
                // You can check mutation.type to see what changed:
                // - 'attributes': if attributes changed
                // - 'childList': if child elements were added/removed
                // - 'characterData': if text content changed
                // const productPointsMinimum = 120;


                const onetime = shadowRoot.querySelector('.rc-selection__onetime');
                const subscriptionElement = shadowRoot.querySelector('.rc-purchase-option__subscription');

                if (onetime && subscriptionElement && !textAdded){

                    widget.shadowRoot.querySelectorAll( 'input[name="purchaseOption"]' ).forEach( function(el){

                        el.addEventListener('change', function (e) {

                            window.updateStickyBasket();

                        });
                    })

                    widget.addEventListener('planChange', function (e) {

                        window.updateStickyBasket();

                    });


                    textAdded = true;

                    const sheet = new CSSStyleSheet();
                    sheet.replaceSync(`div[rc-selected] .subscription-extra { 
                                                display: none; 
                                            }
                                            .subscription-extra, .onetime-extra { 
                                                padding: 0 .5em .5em .5em;
                                            }
                                            .rc-purchase-option {
                                                border-radius: 8px;
                                            }
                                            .rc-purchase-option[rc-selected] {
                                              border-color: var(--pink);
                                              border-width: 2px;
                                            }
                                            .rc-purchase-option__label {
                                              padding: 6px 12px;
                                            }
                                            .subscription-extra, .onetime-extra {
                                              padding: 0 12px 6px 40px;
                                            }
                                            .compact [rc-not-selected] .rc-purchase-option__label {
                                              padding: 6px 12px;
                                            }
                                            .subscription-extra a, .onetime-extra a {
                                              color: var(--pink);
                                            }
                                            .rc-purchase-option__prices {
                                              position: absolute;
                                              right: 12px;
                                              top: 16px;  
                                            }
                                            .rc-purchase-option {
                                              border-color: #d9d9d9;
                                            }
                                            rc-radio-icon.rc-purchase-option__checked-indicator:not([checked]) {
                                              filter: saturate(0)
                                            }
                                            ul {
                                              list-style: none;
                                              padding-left: 0;
                                              margin-top: 5px;
                                              margin-bottom: 9px;
                                            }

                                            ul li {
                                              position: relative;
                                              padding-left: 18px;
                                            }

                                            ul li::before {
                                              content: "";
                                              position: absolute;
                                              left: 0;
                                              top: 4px;
                                              width: 15px;
                                              height: 15px;
                                              background-image: url("https://cdn.shopify.com/s/files/1/0564/5890/3719/files/cheeky-wink.svg");
                                              background-size: contain;
                                              background-repeat: no-repeat;
                                            }

                                            rc-learn-more {
                                              display: none;
                                            }

                                            .rc-purchase-option__selector {
                                              font-size: 16px;
                                            }

                                            .rc-selection__root {
                                              font-size: 13px;
                                            }

                                            .rc-price {font-size:16px;}

                                            .rc-selection__onetime .rc-purchase-option__prices {
                                              top: 10px;
                                            }
                                          `);

                    shadowRoot.adoptedStyleSheets.push( sheet);

                    /* append text including a link to the ontime element */
                    const onetimeDescription = document.createElement('div');
                    onetimeDescription.classList.add('onetime-extra');

                    let pointsText = '';
                    if (window.item && window.item.Value){
                        pointsText = `at least ${window.item.Value * 1 }`

                    }

                    onetimeDescription.innerHTML = `Earn ${pointsText} loyalty points as part of our <a target='_blank' href='/pages/the-good-fat-club'>Good Fat Club</a>`;
                    onetime.append(onetimeDescription);

                    let additionalBullets = null;

                    if (window.extraSubscriptionBullets && Array.isArray(window.extraSubscriptionBullets)) {
                        additionalBullets = window.extraSubscriptionBullets.map(bullet =>
                            `<li>&nbsp;${bullet}</li>`
                        ).join('');
                    } else {
                        additionalBullets = '';
                    }

                    const subscriptionDescription = document.createElement('div');
                    subscriptionDescription.classList.add('subscription-extra');
                    // subscriptionDescription.innerHTML = `<ul><li>&nbsp;Hate running out? Scheduled deliveries keep you stocked</li><li>&nbsp;No strings attached – skip, delay, swap or cancel whenever you need</li</ul></span>`;
                    subscriptionDescription.innerHTML = `<ul>`+
                                                        `<li>&nbsp;Hate running out? Scheduled deliveries keep you stocked</li>` +
                                                        `<li>&nbsp;Stack the savings – 10% off and FREE delivery on every subscription order</li>` +
                                                        `<li>&nbsp;You’re the boss – skip, delay, swap or cancel whenever you like</li>` +
                                                        additionalBullets +
                                                        `</ul>`;

                    subscriptionElement.append(subscriptionDescription);
                }
            });
        });
        

        // Configuration for the observer
        const config = {
            attributes: false,      // observe attribute changes
            childList: true,       // observe child element changes
            subtree: false,         // observe changes in descendants
            characterData: false    // observe changes in text content
        };

        // Start observing the target element
        observer.observe(shadowRoot, config);

    }



});


document.addEventListener("DOMContentLoaded", function() {
 
    const stickyAddToBasket = document.querySelector('.sticky-add');
    const widget = document.querySelector('recharge-subscription-widget');
 
    if ( ! stickyAddToBasket )
        return null;
 
    window.updateStickyBasket = function(){
 
        stickyAddToBasket.querySelector('.product-name').innerHTML = item.Name;
 
        stickyAddToBasket.querySelector('.product-quantity').innerText = document.querySelector('.product__controls-group-quantity .quantity-input .quantity-input__input').value + " x";
 
        if (widget && widget.purchaseOption == 'subscription'){
            if (widget.selectedVariantPlan && widget.prices){
                stickyAddToBasket.querySelector('.subscription-details').innerHTML =  widget.selectedVariantPlan.external_plan_name;
                stickyAddToBasket.querySelector('.product-price').innerHTML = widget.prices.discounted + " <s class='was-price' data-compare-price=''>" + widget.prices.unit + "</s>";
            }
        }else{
            stickyAddToBasket.querySelector('.subscription-details').innerHTML = '';
            stickyAddToBasket.querySelector('.product-price').innerHTML = item.Price;
 
        }
 
    }
 
    window.updateStickyBasket();
 
    document.querySelector('.sticky-add .product-form__cart-submit').addEventListener('click', function(){
        // document.querySelector('form.product-form').submit();
        document.querySelector('form.product-form .product-form__cart-submit').click();
    })
 
    document.addEventListener('product:quantity-update', function(){
        window.updateStickyBasket();
    })
});


document.addEventListener("DOMContentLoaded", function() {
    function centerAllSwipers() {

        document.querySelectorAll('.carousel.swiper').forEach(function(el){

            if (el.swiper){

                el.swiper.params.centeredSlides = true;
                el.swiper.params.centeredSlidesBounds = true;
                el.swiper.params.slidesPerView =  Math.floor( el.swiper.params.slidesPerView );
                el.swiper.params.slidesPerGroup =  1;
                // el.swiper.params.loop = true

                el.swiper.update();

                setTimeout(function() {
                    el.swiper.slideTo(0);

                }, 200);
            }

        })

    }

    window.addEventListener('load', centerAllSwipers);
    window.addEventListener('resize', centerAllSwipers);


});







/**
 *  * Quick search add-to-basket
 *
 *
 * */

document.addEventListener('DOMContentLoaded', function () {
    // The element containing search results (wait for existence if loaded dynamically)
    var searchResults = document.querySelector('.quick-search__results');

    if (!searchResults) return;

    // Helper: Add "Add to Cart" button to a result element if not present
    function addAddToCartButton(resultEl) {

        if (resultEl.querySelector('.quick-add-to-basket')) return; // Avoid duplicate
        // Example: Get a product ID from a data attribute or other source
        resultEl.addEventListener('click', function (e) {

            // let productId = resultEl.closest('form').dataset.currentProductId;
            let productId = resultEl.dataset.addItemId;

            let formData = {
                'items': [{
                    'id': productId, 'quantity': 1
                }]
            };

            // debugger;

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST', headers: {
                    'Content-Type': 'application/json'
                }, body: JSON.stringify(formData)
            })
                .then(response => {

                    // if this was a click on the main cart ... just reload the cart page - otherwise trigger the minicart reload
                    if(resultEl.closest('.shopify-section.cart-section')){
                        window.location.reload();
                    }else{
                        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
                    }

                    response.json().then(function(jsonResponse){
                        if (jsonResponse.items[0]) {

                            const lineItemId = jsonResponse.items[0].id;
                            const quantity = jsonResponse.items[0].quantity - 1;

                            const removeButton = document.createElement('button');
                            // removeButton.classList.add('');
                            removeButton.innerHTML = 'Remove';

                            removeButton.addEventListener('click', function (e) {
                                e.preventDefault();
                                e.stopPropagation()
                                updateCartItem( lineItemId, quantity);
                                resultEl.style.display = 'flex';
                                removeButton.remove();
                            })

                            resultEl.style.display = 'none';
                            resultEl.after(removeButton);

                        }
                    });

                    // return response.json();

                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        });
    }

    // Attach to all current children on init
    searchResults.querySelectorAll('.quick-search__result').forEach(addAddToCartButton);

    // MutationObserver callback: for new nodes
    var observer = new MutationObserver(function (mutationsList) {

        for (var mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length) {
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeType === 1 && node.classList.contains('quick-search__result--product')) {

                        const addButton = node.querySelector('.quick-search__result--add-product');
                        if (addButton) {
                            addAddToCartButton(addButton);

                        }

                    }
                });
            }
        }
    });

    observer.observe(searchResults, { childList: true });

    function updateCartItem(line, quantity) {

        let updates = {
            [line] : quantity
        };

        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ updates})

        })
            .then(response => response.json())
            .then(data => {
                // Handle cart update, e.g., refresh cart UI
                // You can fire a custom event or simply refresh the mini cart, etc.
                document.dispatchEvent(new CustomEvent('apps:product-removed-from-cart', { detail: data }));
                // Optional: update cart UI here
            })
            .catch(error => {
                console.error('Error removing from cart:', error);
            });
    }


    // if the quick searhch gets closed - clear the search
    document.querySelectorAll('.quick-search__overlay, .quick-search__close').forEach(function (el) {el.addEventListener('click', function () {
        document.querySelector('.quick-search__clear').click();
    })})

});



document.addEventListener("DOMContentLoaded", function() {
    import(flu.chunks.swiper).then(function (ref) {

        window.recipeSlider = new ref.Swiper('.recipe-posts .blog-posts__flex', {
                // Enable slide effect (this is default, so you don't actually need to specify it)
                // Specify slide elements
                slideClass: 'recipe-item',
                wrapperClass: 'recipe-item-wrapper',
                modules: [ ref.Navigation ],

                navigation: {
                    nextEl: '.carousel__navigation-button--forward',
                    prevEl: '.carousel__navigation-button--back',
                },
                effect: 'slide',

                // Enable touch swiping
                // touchEventsTarget: 'swiper-wrapper',
                touchRatio: 1,
                touchAngle: 45,
                grabCursor: true,

                // Basic configuration
                slidesPerView: 1,
                spaceBetween: 30,

                // Responsive breakpoints
                // make it a 2-up carousel if over 720
                // make it a 3-up carousel if over 960
                breakpoints: {
                    // 720: {
                    //     slidesPerView: 2,
                    //     spaceBetween: 30
                    // },
                    960: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    }
                },


            }
        )
    } );

});


document.addEventListener("DOMContentLoaded", function() {
    import(flu.chunks.swiper).then(function (ref) {

        window.recipeSlider = new ref.Swiper('.ingredients-youll-need', {
                // Enable slide effect (this is default, so you don't actually need to specify it)
                // Specify slide elements
                slideClass: 'swiper-slide',
                wrapperClass: 'swiper-wrapper',
                modules: [ ref.Navigation ],

                navigation: {
                    nextEl: '.carousel__navigation-button--forward',
                    prevEl: '.carousel__navigation-button--back',
                },
                effect: 'slide',

                // Enable touch swiping
                // touchEventsTarget: 'swiper-wrapper',
                touchRatio: 1,
                touchAngle: 45,
                grabCursor: true,

                // Basic configuration
                slidesPerView: 2,
                spaceBetween: 30,

                // Responsive breakpoints
                // make it a 2-up carousel if over 720
                // make it a 3-up carousel if over 960
                breakpoints: {
                    // 0: {
                    //     slidesPerView: 2,
                    //     spaceBetween: 30
                    // },
                    960: {
                        slidesPerView: 1,
                        spaceBetween: 30
                    }
                },


            }
        )
    } );

});



document.addEventListener("DOMContentLoaded", function() {
    function centerAllSwipers() {

        document.querySelectorAll('.carousel.swiper').forEach(function(el){

            if (el.swiper){

                el.swiper.params.centeredSlides = true;
                el.swiper.params.centeredSlidesBounds = true;
                el.swiper.params.slidesPerView =  Math.floor( el.swiper.params.slidesPerView );
                el.swiper.params.slidesPerGroup =  1;
                // el.swiper.params.loop = true

                el.swiper.update();

                setTimeout(function() {
                    el.swiper.slideTo(0);

                }, 200);
            }

        })

    }

    window.addEventListener('load', centerAllSwipers);
    window.addEventListener('resize', centerAllSwipers);


});

document.addEventListener('DOMContentLoaded', function() {
    let wakeLock = null;
    const wakeLockToggleButtons = document.querySelectorAll('.toggle-cook-mode .toggle-label');

    // Function to request wake lock
    async function requestWakeLock() {
        try {
            wakeLock = await navigator.wakeLock.request('screen');
            return true;
        } catch (err) {
            console.error(`Failed to request wake lock: ${err.message}`);
            return false;
        }
    }

    // Function to release wake lock
    function releaseWakeLock() {
        if (wakeLock) {
            wakeLock.release()
                .then(() => {
                    wakeLock = null;
                })
                .catch((err) => {
                    console.error(`Failed to release wake lock: ${err.message}`);
                });
        }
    }

    // Add click event listeners to all wake lock toggle buttons
    wakeLockToggleButtons.forEach(button => {
        button.addEventListener('click', async () => {
            if (!wakeLock) {
                // If wake lock is not active, request it
                const success = await requestWakeLock();
                if (success) {
                    button.classList.add('active');
                    // alert('Wake lock active');
                }
            } else {
                // If wake lock is active, release it
                releaseWakeLock();
                // alert('Wake lock released');
            }
        });
    });

    // Release wake lock when page becomes hidden
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden' && wakeLock) {
            releaseWakeLock();
            wakeLockToggleButtons.forEach(button => {
                button.classList.remove('active');
            });
        }
    });
});

document.addEventListener("DOMContentLoaded", function() {

  function destroyDisabledSwipers() {
    document.querySelectorAll('[data-enable-mobile-slider="false"] .carousel.swiper').forEach(function(el) {
      if (!el.swiper) return;

      // Destroy the swiper instance
      el.swiper.destroy(true, true);
      el.classList.remove('swiper-initialized');
    });
  }

  window.addEventListener('load', destroyDisabledSwipers);
  window.addEventListener('resize', destroyDisabledSwipers);
});


document.addEventListener("DOMContentLoaded", function() {

    if (!document.body.classList.contains('all-products')) {
        return;
    }

    const allCollectionSliders = document.querySelectorAll('.featured-collection-grid');
    const allNavItems = document.querySelectorAll('a.search-navigation-item');

    allNavItems.forEach(function(el) {

        el.addEventListener('click', function(e) {
            e.preventDefault();

            allNavItems.forEach(function(el) { el.classList.remove('active') });


            const targetId = this.dataset.anchorTarget;

            if (targetId === 'all'){

                this.classList.add('active');

                allCollectionSliders.forEach(div => {
                    div.style.display = 'block';
                });

                return;

            }

            allCollectionSliders.forEach(div => {
                div.style.display = 'none';
            });

            // Show the specific div that matches the anchorTarget
            if (targetId) {
                const targetDiv = document.getElementById(targetId);
                if (targetDiv) {
                    targetDiv.style.display = 'block';
                }
                this.classList.add('active');
            }

        });
    });
});

